// extracted by mini-css-extract-plugin
module.exports = {"controlPanel":"ControlPanel__controlPanel__EW+yy","item":"ControlPanel__item__p7WAP","screenShare":"ControlPanel__screenShare__3pKjk ControlPanel__item__p7WAP"};